import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [selectedMenu, setSelectedMenu] = useState("Blockchain & DeFi");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const menuItems = [
    {
      name: "Blockchain & DeFi",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Artificial Intelligence",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Gaming",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Web3 & Metaverse",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Marketing",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Exchange",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Trading Bot",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "M | M",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est nisi fugiat explicabo soluta temporibus quod veritatis animi! Laborum, deleniti.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
  ];

  return (
    <>
      <div className="nav_bg">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light py-3 justify-content-between w-100">
            <div className="d-flex justify-content-between w-100 toggle">
            <Link className="navbar-brand text-white" to="/">
               <img src="assets/img/639b830a4cbdd20fd5f3a9a9/logo.svg" alt="" />
              </Link>
              <button
                className="navbar-toggler toggle_btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/header_toggle.svg"
                  alt=""
                />
              </button>
            </div>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 d-flex gap-3 font_14 fw-bold pe-lg-3 pe-0">
                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu active text-white ps-lg-0 ps-4"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu text-white ps-lg-0 ps-4"
                    to="/about"
                  >
                    About
                  </Link>
                </li>
                <li className="nav-item dropdown nav_menu_padding">
                  <a
                    className="nav-link dropdown-toggle nav_menu text-white ps-lg-0 ps-4"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Solutions
                  </a>
                  <div
                    className={`dropdown-menu sub_menus menu_width ${
                      isDropdownOpen ? "d-block" : "d-none"
                    }`}
                  >
                    <div className="d-flex">
                      <div className="side_menu col-lg-4">
                        {menuItems.map((item) => (
                          <div
                            className="d-flex justify-content-between"
                            onClick={() => setSelectedMenu(item.name)}
                          >
                            <a
                              key={item.name}
                              className={`dropdown-item nav_menu mb-2 p-0 font_14 ${
                                selectedMenu === item.name ? "active" : ""
                              }`}
                              href="#"
                            >
                              {item.name}
                            </a>
                            <img
                              src="assets/img/639b830a4cbdd20fd5f3a9a9/right-arrow.svg"
                              alt=""
                              className="d-lg-block d-none"
                            />
                          </div>
                        ))}
                      </div>
                      <div className="dropdown-content col-lg-8 ms-4 d-lg-flex d-md-none align-items-start ps-0">
                        <div className="w-50">
                          <h6 className="fw-bold font-12">{selectedMenu}</h6>
                          <p className="font_14 fw-normal">
                            {
                              menuItems.find(
                                (item) => item.name === selectedMenu
                              )?.content
                            }
                          </p>
                        </div>
                        <img
                          src={
                            menuItems.find((item) => item.name === selectedMenu)
                              ?.img
                          }
                          alt={selectedMenu}
                          className="ms-3 img-fluid"
                          style={{ maxWidth: "150px", height: "auto" }}
                        />
                      </div>
                    </div>
                  </div>
                </li>
                <li className="nav-item nav_menu_padding">
                  <a
                    className="nav-link nav_menu text-white ps-lg-0 ps-4"
                    href="/"
                  >
                    Service
                  </a>
                </li>
                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu text-white ps-lg-0 ps-4"
                    to="/blockchain-consulting"
                  >
                    Consulting
                  </Link>
                </li>
                <li className="nav-item nav_menu_padding">
                  <a className="nav-link nav_menu text-white ps-lg-0 ps-4" href="/">
                    Blockchain
                  </a>
                </li>
              </ul>
            </div>
            <form className="d-lg-flex d-none">
              <Link to="/contact" className="btn blockcryp_button font_14 fw-bold">
                Contact
              </Link>
            </form>
          </nav>
        </div>
      </div>
    </>
  );
}
